import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  private readonly _httpClient = inject(HttpClient);

  onDownloadDocument(documentUrl: string, documentName: string): void {
    this._httpClient
      .get(documentUrl, { responseType: 'blob' })
      .subscribe((blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = documentName;
        a.click();
        URL.revokeObjectURL(objectUrl);
      });
  }
}
